import { createRecipeSlug } from "base/utils";
import { Link } from "react-router-dom";
import logo from "../../images/BlogFreeRecipe-drkBkgrd.png";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PRIORITY_LABELS = [
  "high protein",
  "vegan",
  "vegetarian",
  "gluten free",
  "whole30",
];

const createRecipeUrl = (recipe) => {
  const slug = createRecipeSlug(recipe);
  return slug ? `/recipes/${slug}` : `/recipeDetails/${recipe?.id}`;
};

const getTotalMinutes = (recipe) => {
  const total = Number(recipe.total_time);

  if (Number.isFinite(total) && total > 0) {
    return total;
  }

  const prep = Number(recipe.prep_time);
  const cook = Number(recipe.cook_time);

  const calculatedTotal =
    (Number.isFinite(prep) && prep > 0 ? prep : 0) +
    (Number.isFinite(cook) && cook > 0 ? cook : 0);

  return calculatedTotal > 0 ? calculatedTotal : null;
};

const getPreviewBadges = (badges) => {
  if (!Array.isArray(badges)) {
    return [];
  }

  const uniqueBadges = [
    ...new Map(
      badges
        .filter((badge) => badge?.name?.trim())
        .map((badge) => [badge.name.trim().toLowerCase(), badge]),
    ).values(),
  ];

  const priorityBadges = uniqueBadges.filter((badge) =>
    PRIORITY_LABELS.includes(badge.name.trim().toLowerCase()),
  );

  const otherBadges = uniqueBadges.filter(
    (badge) => !PRIORITY_LABELS.includes(badge.name.trim().toLowerCase()),
  );

  return [...priorityBadges, ...otherBadges];
};

const RecipeCollapsed = ({ handleToggle, recipe, badges }) => {
  const recipeName = recipe.recipe_name || "Recipe";
  const mainPicture =
    recipe.main_picture || recipe.additional_pictures?.[0] || logo;

  const recipeUrl = createRecipeUrl(recipe);
  const totalMinutes = getTotalMinutes(recipe);
  const previewBadges = getPreviewBadges(badges ?? recipe.badges);

  return (
    <div className="Recipe-Preview">
      <Link
        to={recipeUrl}
        className="Recipe-Preview-Image-Link"
        aria-label={`View recipe: ${recipeName}`}
      >
        <img
          src={mainPicture}
          alt=""
          className={`Recipe-Preview-Image ${
            mainPicture === logo ? "Recipe-Preview-Image-Fallback" : ""
          }`}
          loading="lazy"
          decoding="async"
          width={600}
          height={400}
        />
      </Link>
      <div className="Row">
        <div className="Recipe-Preview-Content">
          <h3 className="Recipe-Preview-Title Row">
            <Link to={recipeUrl} className="Recipe-Preview-Title-Link">
              {recipeName}
            </Link>
            <button className="Dark-Gray expand-icons" onClick={handleToggle}>
              {window.innerWidth > 600 ? (
                <svg
                  className="w-6 h-6 text-gray-800 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M8 4H4m0 0v4m0-4 5 5m7-5h4m0 0v4m0-4-5 5M8 20H4m0 0v-4m0 4 5-5m7 5h4m0 0v-4m0 4-5-5"
                  />
                </svg>
              ) : (
                <FontAwesomeIcon icon={faArrowDown} />
              )}
            </button>
          </h3>

          {totalMinutes !== null && (
            <p className="Recipe-Preview-Time">{totalMinutes} minutes total</p>
          )}

          {previewBadges.length > 0 && (
            <ul
              className="Recipe-Preview-Badges"
              aria-label={`Recipe badges for ${recipeName}`}
              role="list"
            >
              {previewBadges.map((badge) => (
                <li
                  key={badge.name.trim().toLowerCase()}
                  className="Recipe-Preview-Badge-Item"
                >
                  {badge.image ? (
                    <img
                      src={badge.image}
                      alt={badge.name}
                      title={badge.name}
                      className="Recipe-Preview-Badge-Image"
                      loading="lazy"
                      decoding="async"
                      width={40}
                      height={40}
                    />
                  ) : (
                    <span className="Recipe-Preview-Badge">{badge.name}</span>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecipeCollapsed;
